import { Module } from 'vuex-smart-module';
import StaffDetailActions from './actions';
import StaffDetailGetters from './getters';
import StaffDetailMutations from './mutations';
import StaffDetailState from './state';

export default new Module({
  state: StaffDetailState,
  mutations: StaffDetailMutations,
  actions: StaffDetailActions,
  getters: StaffDetailGetters,
});
